import React from 'react'
import {connect} from 'react-redux'
import { Container, Row, Col, Button, Label, Input} from 'reactstrap';
import moment from 'moment';
import {cancelCourse} from '../actions/coursesActions'
import {fetchMB} from '../utils/MojBus'
import {formatCurrency} from '../utils/Strings'


const mapStateToProps = state => {
  return {
    ...state.courses.currCourse,
    seatsQtyNormal: state.courses.filter.seatsQtyNormal,
    seatsQtyReduced: state.courses.filter.seatsQtyReduced,
    agentLogin: state.user.agentLogin,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onCancel: () => {
      dispatch(cancelCourse())
    }
//    onGetCourses: (ownProps) => {
//      dispatch(fetchCourses(ownProps.agentLogin))
//    },
  }
}

class CourseReserve extends React.Component{
  constructor (props) {
    super(props)
    this.state = {
      resStatus: 0,
      errorNo: 0,
      errorDesc: '',
      startAddress:'',
      finishAddress:''
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
  }
//  <Row>
//        <Col md="12"><pre>{JSON.stringify(this.props.courses, null, 2)}</pre></Col>
//        </Row>

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
    //console.log(name + ' -> ' + value);
  }
  handleCancel(event) {
    event.preventDefault();
    this.props.onCancel();
  }
  handleSubmit(event) {
    event.preventDefault();
    //walidacja
    if (!this.state.lastName)
      return alert('Nie wprowadzono nazwiska pasażera')
    // if (!this.state.firstName)
    //   return alert('Nie wprowadzono imienia pasażera')
    // if (!this.state.phone)
    //   return alert('Nie wprowadzono nr telefonu pasażera')

    this.setState(
      {resStatus:1}
    )
    let reserveReq={
      status: 'confirm',
      idCourse: this.props.idCourse,
      startStopNr: this.props.startStopNr,
      finishStopNr: this.props.finishStopNr,
      seatsQtyNormal: this.props.seatsQtyNormal,
      seatsQtyReduced: this.props.seatsQtyReduced,
      lastName: this.state.lastName,
      firstName: ((this.state.firstName) ? this.state.firstName: ''),
      phone: ((this.state.phone) ? this.state.phone: ''),
      email: this.state.email,
      taxNo: this.state.taxNo,
      totalPrice: this.props.totalPrice,
      agent: this.props.agentLogin,
    }
    if (this.props.hasOwnProperty('services')){
      let services = {}
      if (this.state.startAddress.length>0){
        let startAddressObj = {address: this.state.startAddress}
        services = {
          ...services,
          startAddress: startAddressObj
        }
      }
      if (this.state.finishAddress.length>0){
        let finishAddressObj = {address: this.state.finishAddress}
        services = {
          ...services,
          finishAddress: finishAddressObj
        }
      }

      reserveReq = {
        ...reserveReq,
        services: services
      }
    }
    console.log("Reserve Request", reserveReq)
    //this.state.onFetchCourses(this.state, searchReq)
    var that=this
    fetchMB('reserve', reserveReq, true)
    .then(
      function(json){
        //console.log('JSON', json)
        if (json.status==='OK'){
          //return dispatch(setCourseList(json.courses, apiRequest))
          that.setState(
            {resStatus: 2,
             ticketUrl: json.ticketUrl,
             idReservation: json.idReservation,
            }
          )
        }
        else
          that.setState(
            {resStatus: 101,
             errorNo: json.errorNo,
             errorDesc: json.errorMessage,
            }
          )
      },
      function(error){
        //return dispatch(error(ERR_COMMUNICATION))
        that.setState(
          {resStatus: 102}
        )
      }
    )
  }

  renderForm() {
    var lW=3 //left width
    var rW=9 //right width
    var isStartAddress=false
    var startAddressLabel = "Odbiór spod adresu"
    var isFinishAddress=false
    var finishAddressLabel = "Dowóz pod adres"


    if (this.props.hasOwnProperty('services')){
      var services=this.props.services
      if (services.hasOwnProperty('startAddress')){
        isStartAddress=true
        let price = services.startAddress.price || 0
        if (price>0){
          startAddressLabel += " (+" + price + " zł.)"
        }
      }
      if (services.hasOwnProperty('finishAddress')){
        isFinishAddress=true
        let price = services.finishAddress.price || 0
        if (price>0){
          finishAddressLabel += " (+" + price + " zł.)"
        }
      }
    }

    return (
      <Container fluid className="defForm">
        <h3>Formularz rezerwacyjny</h3>
        <Row className="align-items-center">
          <Col xs="12" sm={lW}><Label>Przewoźnik:</Label></Col>
          <Col sm={rW}>
              <span className="town">{this.props.companyName}</span>
          </Col>
        </Row>
        <Row className="align-items-center">
          <Col xs="12" sm={lW}><Label>Wyjazd:</Label></Col>
          <Col sm={rW}>
              <span className="town">{this.props.startTown}</span>
              <span className="street">{', ' + this.props.startAddress}</span>
          </Col>
        </Row>
        <Row className="align-items-center">
          <Col xs="12" sm={lW}><Label>Przyjazd:</Label></Col>
          <Col sm={rW}>
              <span className="town">{this.props.finishTown}</span>
            <span className="street">{', ' + this.props.finishAddress}</span>
          </Col>
        </Row>
        <Row className="align-items-center">
          <Col xs="12" sm={lW}><Label>Data kursu:</Label></Col>
          <Col sm={rW}>
            <span className="startTime">{moment(this.props.startDateTime).format('YYYY-MM-DD HH:mm')}</span>
            <span className="finishTime">{' - ' + moment(this.props.finishDateTime).format('HH:mm')}</span>
          </Col>
        </Row>
        <Row className="align-items-center">
          <Col xs="12" sm={lW}><Label>Ilość biletów normalnych:</Label></Col>
          <Col sm={rW}>
              {this.props.seatsQtyNormal}
          </Col>
        </Row>
        <Row className="align-items-center">
          <Col xs="12" sm={lW}><Label>Ilość biletów ulgowych:</Label></Col>
          <Col sm={rW}>
              {this.props.seatsQtyReduced}
          </Col>
        </Row>
       <Row className="align-items-center">
          <Col xs="12" sm={lW}><Label>Wartość biletu:</Label></Col>
          <Col sm={rW} className="amount">
              {formatCurrency(this.props.totalPrice)}
          </Col>
        </Row>
       <Row className="align-items-center">
          <Col xs="12" sm={lW}><Label>Imię:</Label></Col>
          <Col sm={rW}>
            <Input type="text"
              value={this.state.firstName}
              placeholder="Imię pasażera"
              name="firstName"
              onChange={this.handleInputChange}
            />
          </Col>
        </Row>
       <Row className="align-items-center">
          <Col xs="12" sm={lW}><Label>Nazwisko:</Label></Col>
          <Col sm={rW}>
            <Input type="text"
              value={this.state.lastName}
              placeholder="Nazwisko pasażera"
              name="lastName"
              required
              onChange={this.handleInputChange}
            />
          </Col>
        </Row>
       <Row className="align-items-center">
          <Col xs="12" sm={lW}><Label>Telefon:</Label></Col>
          <Col sm={rW}>
            <Input type="text"
              value={this.state.phone}
              placeholder="Telefon do pasażera"
              name="phone"
              onChange={this.handleInputChange}
            />
          </Col>
        </Row>

        <Row className="align-items-center">
          <Col xs="12" sm={lW}><Label>Adres email:</Label></Col>
          <Col sm={rW}>
            <Input type="email"
              value={this.state.email}
              placeholder="Email do pasażera"
              name="email"
              onChange={this.handleInputChange}
            />
          </Col>
        </Row>

        <Row className="align-items-center">
          <Col xs="12" sm={lW}><Label>NIP nabywcy:</Label></Col>
          <Col sm={rW}>
            <Input type="text"
              value={this.state.taxNo}
              placeholder="NIP nabywcy"
              name="taxNo"
              onChange={this.handleInputChange}
            />
          </Col>
        </Row>

        { isStartAddress === true &&
          <Row className="align-items-center">
            <Col xs="12" sm={lW}><Label>{startAddressLabel}:</Label></Col>
            <Col sm={rW}>
              <Input type="text"
                value={this.state.startAddress}
                placeholder="Odbiór spod adresu"
                name="startAddress"
                onChange={this.handleInputChange}
              />
            </Col>
          </Row>
        }
        { isFinishAddress === true &&
          <Row className="align-items-center">
            <Col xs="12" sm={lW}><Label>{finishAddressLabel}:</Label></Col>
            <Col sm={rW}>
              <Input type="text"
                value={this.state.finishAddress}
                placeholder="Dowóz pod adres"
                name="finishAddress"
                onChange={this.handleInputChange}
              />
            </Col>
          </Row>
        }


        <Row className="align-items-center">
          <Col xs="0" sm={lW}></Col>
          <Col xs="6" sm={{size: 3, offset: 1}}><Button color="danger" size="lg" onClick={this.handleSubmit}>Rezerwuj</Button></Col>
          <Col xs="6" sm={{size: 3, offset: 1}}><Button color="danger" size="lg" onClick={this.handleCancel}>Anuluj</Button></Col>
        </Row>
      </Container>
    )
  }


  renderPending() {
    return (
      <div className="pendingText">
        Trwa rezerwacja...
      </div>
    )
  }

  renderConfirmation(){
    return (
      <Container fluid className="defForm">
        <h3>Potwierdzenie rezerwacji</h3>
        <Row className="align-items-center">
          <Col>Rezerwacja została zarejestrowana w systemie</Col>
        </Row>
        <Row className="align-items-center">
          <Col>Nr rezerwacji: {this.state.idReservation}</Col>
        </Row>
        <Row className="align-items-center">
          <Col>Link do potwierdzenia: <a href={this.state.ticketUrl} target="_blank" rel="noopener noreferrer">{this.state.ticketUrl}</a></Col>
        </Row>
        <Row>
          <Col><a href={this.state.ticketUrl} target="_blank" rel="noopener noreferrer" className="btn btn-primary btn-lg" role="button" aria-pressed="true">Wydruk potwierdzenia</a></Col>
          <Col><Button color="danger" size="lg" onClick={this.handleCancel}>Powrót</Button></Col>
        </Row>
      </Container>
    )
  }

  renderError(){
    return (
      <div className="center">
        <p> </p>
        <p>Błąd {this.state.errorNo} {this.state.errorDesc}</p>
        <Button color="danger" size="lg" onClick={this.handleCancel}>Anuluj</Button>
      </div>
    )
  }

  render() {
    switch (this.state.resStatus){
      case 0: //new
        return this.renderForm()
      case 1: //pending
        return this.renderPending()
      case 2:
        return this.renderConfirmation()
      case 101:
      case 102:
        return this.renderError();
      default:
        break
    }
  }

}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CourseReserve)


// WEBPACK FOOTER //
// ./src/containers/CourseReserve.js